import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import * as SecureLS from "secure-ls";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ExcelServicesService } from "../../../services/excel.service";
import { Component, OnInit } from "@angular/core";
import { StorageService } from "../../../services/storage.service";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-staff-usage-report",
  templateUrl: "./staff-usage-report.component.html",
  styleUrls: ["./staff-usage-report.component.css"],
})
export class StaffUsageReportComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  total_count = 0;
  video: any;
  vid: any;
  maxDate = new Date();
  getVideo: any;
  videoList: any[] = [];
  searchForm: FormGroup;
  uivideoList: any;
  excelVideoList: any[];
  filter_from: any;
  filter_end: any;
  prolength: number = 0;
  form: FormGroup;
  batch_id: string;
  filter: any;
  class: any;
  batch: any;
  total: number;
  batchData1: any;
  recrange: any;
  dropbox: Array<Object> = [];
  allVideoDetails: any[] = [];
  check: number;
  filtervalues: boolean;
  chiparray = [];
  p: number;
  offset: number = 1;
  limit: number = 10;
  pagedItems: any[];
  pageshow: boolean = true;
  htmlpageshow: boolean;
  page_count: any[];
  countvalue: number = 0;
  department_id: string;
  department: any;
  selectedList: any;
  dept: any;
  hod: any;
  sessionData: any;
  minDate: Date;
  findedVal: any;
  role: number;
  professor_id: any;
  professorname: Object;
  professorData: any;
  constructor(
    private storageService: StorageService,
    public globalService: GlobalService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private ExcelServicesService: ExcelServicesService,
    public commonService: CommonService

  ) {
    this.hod = this.storageService.getHod();
    this.role = this.storageService.getRole();
  }
  async ngOnInit() {
    this.maxDate = new Date();
    this.minDate = new Date();
    this.searchForm = this.fb.group({
      id: [""],
      date: ["", [Validators.required]],
      depname: [null],
      proname: [""],
      session: [null],
    });
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
    
    if (this.storageService.getRole() == 4 && this.hod !== 1 ) {
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].setValue(this.professor_id);
      this.searchForm.controls["proname"].disable();
    }
    this.getDepartment();
    this.getProfessor();
    this.getSession();
    //this.getStaffUsageReport();
  }
  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      department_id: this.department_id,
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = this.department["content"];
    this.spinner.hide();
  }

  async getProfessor() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.professorname = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = this.professorname["content"];
    if (this.storageService.getRole() == 4 && this.hod !== 1) {
      this.professor_id = this.storageService.getProfessor();
      if (this.professor_id != undefined && this.professor_id != "") {
        var proffessor = this.professorData.filter(
          (x) => x.id == this.professor_id
        );
        if (proffessor.length > 0 && proffessor[0]) {
          this.chiparray.push(
            "Proff:" +
              " " +
              proffessor[0].first_name +
              " " +
              proffessor[0].last_name
          );
        }
      }
    }
    this.spinner.hide();
  }


  async getPage(offset: number) {
    this.offset = offset;
    await this.getStaffUsageReport();
    const res = await this.serverCall(this.videoList, offset);
    this.total = this.countvalue;
    this.p = offset;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], offset: number) {
    const perPage = this.limit;
    const start = (offset - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  get forms() {
    return this.searchForm.controls;
  }

  async getSession() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );

    this.sessionData = session["content"];
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.findedVal = this.sessionData.find(
      (list) => list.session === this.searchForm.controls['session']?.value
    );
    this.onSessionChangeEvent(true);
    this.doFilter();
    this.spinner.hide();
  }

  onSessionChangeEvent(isInitLoad?) {
    this.forms["date"].setValue(null);
    this.setFilteredDate(null);
    let sessionVal = this.forms["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData.find(
        (list) => list.session === sessionVal
      );
      this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
      this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
      this.minDate.setFullYear(
        new Date(this.findedVal.start_date).getFullYear()
      );
      this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
      this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
      this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      if (isInitLoad) {
        let splitedChipArray = null;
        if(this.chiparray.length){
          this.chiparray.forEach((elem)=>{
            if(elem.split(" : ")[0] === "Date" ){
              splitedChipArray =  elem.split(" : ")[1].split(" - ");
            }
          })
        }
        if(splitedChipArray?.length){
          const convertedDates = splitedChipArray.map(dateStr => new Date(dateStr));
          this.forms["date"].setValue(convertedDates);
          this.setFilteredDate(convertedDates);
        }else{
        this.forms["date"].setValue([new Date(), new Date()]);
        this.setFilteredDate([new Date(), new Date()]);
      }
    }
    } else {
      this.forms["date"].setValue(null);
      this.setFilteredDate(null);
    }
  }

  setFilteredDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;
      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD");
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
            new Date(this.filter_end).getTime()
        ) / oneDay;
      if (-diffDays > 180) {
        Swal.fire({
          text: "Please select dates within 180 days",

          icon: "warning",

          confirmButtonText: "OK",

          confirmButtonColor: "#808080",
        });
        this.searchForm.controls["date"].setValue(""); 
      }
    }
  }

  getUtcToLocale(dateValue, timeValue,isDateRequested) {
    return this.globalService.getUtcToLocale(dateValue, timeValue, isDateRequested);
  }

  getvalue(event: any, rec: any, offset: number) {
    this.recrange = rec;
    this.offset = offset;
    this.exportAsXLSX();
  }

  async dropboxdown() {
    this.dropbox = [];
    var count = 1000,
      tempcount = 1000,
      c1,
      c2;
    var offset = 0;
    this.check = Math.ceil(this.total_count / count);
    var cvar = 1;
    for (let i = 1; i <= this.check; i++) {
      c1 = cvar;
      c2 = count;
      cvar = cvar + tempcount;
      count += tempcount;
      this.dropbox.push({ value: i, records: c1 + "-" + c2, offset: offset });
      offset += 1000;
    }
  }

  async getStaffUsageReport() {

    if (this.offset === 1) {
      this.videoList = [];
    }
    this.spinner.show();

    let requestPayload = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      start_date: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      end_date: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      department_id: this.department_id? this.department_id : this.searchForm.controls["depname"].value,
      professor_id: this.professor_id? this.professor_id : this.searchForm.controls["proname"].value,
      offset: this.offset,
      limit: this.limit,
      session_id: this.findedVal?.id,
    };

    let staffusageReport: any = await this.globalService.get(
      "classVideoDetail/get-staffusage-report",
      requestPayload
    );
    const dateKeyExists = this.chiparray.some((chip) => chip.startsWith("Date :"));

    if (!dateKeyExists) {
      this.chiparray.push("Date :" + " " + requestPayload.start_date + " - " + requestPayload.end_date);
    }
    this.videoList = staffusageReport?.content?.rows;
    this.countvalue = staffusageReport?.content?.count;

    if (staffusageReport["status"] === 200) {
      this.pageshow = true;
      this.spinner.hide();
    }
    if (this.pageshow === true) {
      this.page_count = [];
      let page_count = Math.ceil(this.total_count / this.limit);
      if (page_count > 1) {
        this.htmlpageshow = true;
      } else {
        this.htmlpageshow = false;
      }
      this.spinner.hide();
    }
    (error) => {
      this.videoList = [];
      this.spinner.hide();
    };

    this.spinner.hide();
    this.dropboxdown();
  }

  async exportAsXLSX(): Promise<void> {
    this.spinner.show();
    var count = 1000;

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      start_date: this.filter_from || moment(new Date()).format("YYYY-MM-DD"),
      end_date: this.filter_end || moment(new Date()).format("YYYY-MM-DD"),
      department_id: this.department_id,
      offset: this.offset ? this.offset : 0,
      limit: 1000,
      isdownload: true,
      session_id: this.findedVal?.id,
    };
    this.getVideo = await this.globalService.get(
      "classVideoDetail/get-staffusage-report",
      filter
    );

    this.excelVideoList = this.getVideo?.content?.rows;

    this.uivideoList = this.excelVideoList.map((item: any) => {
      return {
        STAFF_NAME: `${item.first_name} ${item.last_name}`,
        INACTIVE_VIDEOS: item.inactive_video,
        VIDEOS_CAPTURED: item.captured_video,
        NOT_COMPLETED_VIDEOS: item.noncaptured_video,
        TOTAL_CLASSES: item.total_classes,
      };
    });

    this.ExcelServicesService.exportAsExcelFile(
      this.uivideoList,
      "Staff_Usage_Report" + "" + [this.recrange]
    );
    this.recrange = "";
    this.offset = 1;
    this.spinner.hide();
  }

  openScrollableContent(longContent) {
    // this.findedVal = null;
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
      // this.searchForm.reset();
    }
    // this.searchForm.reset();
    if(!this.forms["session"].value){
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );}
    this.onSessionChangeEvent(true);
    if (this.storageService.getRole() === 4 && this.hod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].disable();
    }
    if (this.storageService.getRole() === 4 && this.hod !== 1) {
      this.searchForm.controls["proname"].setValue(
        this.storageService.getProfessor()
      );
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].disable(); 
    }
  }

  loadMore(index) {
    this.pageshow = true;
    this.offset = index;
    this.getStaffUsageReport();
  }
  previous() {
    this.pageshow = true;
    this.offset = this.offset - 1;
    this.getStaffUsageReport();
  }
  next() {
    this.pageshow = true;
    this.offset = this.offset + 1;
    this.getStaffUsageReport();
  }

  doFilter() {
    this.filtervalues = true;
    this.chiparray = [];
    if(this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }
    // if (this.filter != undefined && this.filter != "") {
    //   this.chiparray.push(
    //     "Date :" + " " + this.filter_from + " - " + this.filter_end
    //   );
    // }
    if (this.professor_id != undefined && this.professor_id != "") {
      var proffessor = this.professorData.filter(
        (x) => x.id == this.professor_id
      );
      this.chiparray.push(
        "Proff:" +
          " " +
          proffessor[0].first_name +
          " " +
          proffessor[0].last_name
      );
    }

    if (this.batch_id != undefined && this.batch_id != "") {
      var batch = this.batchData1.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }
    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }
    this.batch_id = this.searchForm.controls['batchname']?.value;
    this.department_id =  this.department_id ? this.department_id : this.searchForm.controls["depname"]?.value;
    this.pageshow = true;
    this.offset = 1;
    this.getStaffUsageReport();
  }
  res() {
    this.searchForm.reset();
    this.chiparray = [];
    this.forms["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.findedVal = this.sessionData?.find(
      (list) => list.session === this.searchForm.controls["session"]?.value
    ) || null;
    this.chiparray.push(
      "Session : " + this.searchForm.controls["session"]?.value
    );
    this.filtervalues = false;
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);}
      if (this.storageService.getRole() == 4 && this.hod != 1) {
      var proff = this.professorData.filter((x) => x.id == this.professor_id);
      this.chiparray.push("Proff:" + " " + proff[0].first_name + " " + proff[0].last_name);}
    if (this.storageService.getRole() != 4) {
      this.department_id = null;
      this.professor_id = null;
    }
    this.filter_from = moment(new Date()).format("YYYY-MM-DD");
    this.filter_end = moment(new Date()).format("YYYY-MM-DD");
    this.batch_id = null;
    this.department_id = null;
    this.videoList = [];
    this.prolength = 0;
    this.total_count = 0;
    this.countvalue = 0;
    this.getStaffUsageReport();
    this.searchForm.reset();
    this.pageshow = true;
    this.offset = 1;
  }
  paginationCount(value) {
    this.offset = 1;
    if (value >= 5) {
      this.limit = value;
    }
    this.getStaffUsageReport();
  }
  async openXl(content, selectedList, summary_type) {
    this.selectedList = { ...selectedList, department_id: this.department_id, summary_type: summary_type };
    this.modalService.open(content, { size: "xl" });
  }
}
